import { CSSProperties } from "react";
import { theme } from "./theme";

export const styles: Record<string, CSSProperties> = {
    wrapper: {
        height: "100vh",
        minHeight: 0,
        width: "100%",
        padding: "1.05rem 1.15rem",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",
        fontWeight: 600,
    },
    container: {
        width: "min(1480px, 100%)",
        maxWidth: "1480px",
        height: "100%",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
    },
    converterHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "0.78rem",
        gap: "0.85rem",
        flexWrap: "wrap",
        flexShrink: 0,
    },
    converterHeaderTitle: {
        margin: 0,
        fontSize: "1.48rem",
        letterSpacing: "0",
        color: theme.fgStrong,
        fontWeight: 800,
        lineHeight: 1.05,
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        flexWrap: "wrap",
    },
    customCardSite: {
        background: theme.bgSurface,
        borderRadius: theme.radius,
        border: `1px solid ${theme.borderSoft}`,
        boxShadow: theme.shadowSoft,
        padding: "0.95rem",
        margin: "0 auto 0.82rem",
        width: "100%",
        flexShrink: 0,
    },
    customCardPath: {
        background: "transparent",
        borderRadius: 0,
        border: "none",
        boxShadow: "none",
        padding: 0,
        margin: "0 auto",
        backdropFilter: "none",
        width: "100%",
        flex: 1,
        minHeight: 0,
    },
};
